.root {
  .track {
    background-color: var(--mantine-color-otherWhite-1);
    border: 1px solid var(--mantine-color-tertiary-7);

    &[data-disabled] {
      background-color: var(--mantine-color-tertiary-0);
      border: 1px solid var(--mantine-color-tertiary-2);
    }
  }

  .thumb {
    background-color: var(--mantine-color-tertiary-7);

    &:before {
      content: none;
    }
  }

  &[data-checked] {
    .track {
      border: none;
      background-color: var(--mantine-color-green-5);
    }

    .thumb {
      background-color: var(--mantine-color-otherWhite-1);
    }
  }
}

.input {
  &:disabled + span {
    background-color: var(--mantine-color-tertiary-0);
    border-color: var(--mantine-color-tertiary-2);
  }
}
